export class DialogData {
   public title?: string;
   public msg?: string;
   public html?: string;
   public subMsg?: string;
   public icon?: string;
   public classDialog?: "error" | "" = "";
   public err?: any;
   public type?: "simple" | "confirm" | "confirm_alt";
   public typeDialog?: "error" | "success";
   public actionButton?: {
      text: string,
      onClick: ()=>any
   }
   public titleButton?: string = "Vedi";
   public duration?: number = 3000;

   public btn_confirm?: string = "OK";
   public btn_confirm_alt?: string = "Conferma";
   public btn_cancel?: string = "Annulla";
   public show_confirm?: boolean = true;
   public show_confirm_alt?: boolean = false;
   public show_confirm_alt_red?: boolean = false;
}

export class DialogDataError {
   public title?: string;
   public msg?: string;
   public subMsg?: string;
   public icon?: string;
   public classDialog?: "error" | "" = "";
   public err?: any;
   public type?: "simple" | "confirm" | "confirm_alt";
   public typeDialog?: "error" | "success";
   public actionButton?: {
      text: string,
      onClick: ()=>any
   }
   public titleButton?: string = "Vedi";
   public duration?: number = 3000;

   public btn_confirm?: string = "OK";
   public btn_confirm_alt?: string = "Conferma";
   public btn_cancel?: string = "Annulla";
}
